export default __webpack_public_path__ + "static/media/GREEN_STOREYS_BROCHURE.6602c682.pdf";